import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Traits from "./pages/Traits/Traits";
import PlayModuleBtn from "./pages/Traits/PlayModuleBtn";

import MyDashboard from "./pages/MyDashboard/MyDashboard";
import TeamDashboard from "./pages/TeamDashboard/TeamDashboard";
import Leaderboard from "./pages/Leaderboard/Leaderboard";
import TraitsDetail from "./pages/MyDashboard/TraitsDetail";
import FullScreenLoader from "./FullScreenLoader/fullScreenLoader";


const AppRouter = () => {
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [permissions, setPermissions] = useState([]);
  const [loading,setLoading]=useState(true);

  useEffect(() => {
    if (userData?.user?.permissions?.length > 0) {
      setPermissions([...userData.user.permissions]);
      setLoading(false)
    }
  }, [userData.user]);

  return (
   <>
   {
    loading ?
    <FullScreenLoader loading={loading}/>
    :
     <Routes>
     {/* {permissions.includes("CONTENT.VIEW") &&
     <Route path='/dashboard' element={<MyDashboard />} />} */}
     {permissions.includes("PSY.DASHBOARD.MY") && (
       <Route path="/dashboard" element={<MyDashboard />} />
     )}
     {permissions.includes("PSY.DASHBOARD.TEAM") && (
       <Route path="/team-dashboard" element={<TeamDashboard />} />
     )}

     {permissions.includes("PSY.DASHBOARD.LEADERBOARD") && (
       <Route path="/leaderboard" element={<Leaderboard />} />
     )}

     {permissions.includes("PSY.TRAITS") && <Route path="/traits" element={<Traits />} />}

     {permissions.includes("PSY.TRAITS.NUM") && (
       <Route path="/traits/insights/:id/:uuid" element={<TraitsDetail />} />
     )}
     {permissions.includes("PSY.TRAITS.NUM") && (
       <Route path="/traits/playmodule/:id" element={<PlayModuleBtn />} />
     )}
     <Route path="*" element={<Navigate to={"/dashboard"} />} />
   </Routes>
   }
   </>
  );
};
export default AppRouter;
